
<template>
  <div>
    <v-row>
      <v-col cols="12" md="7">
        <v-text-field v-model="client.name" :rules="required" label="Nome" prepend-icon="mdi-account"></v-text-field>
      </v-col>
      <v-col cols="12" md="5">
        <v-text-field v-model="client.CPF" :rules="[...required, ...cpf]" label="CPF" prepend-icon="mdi-badge-account-outline" v-mask="'###.###.###-##'"></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import validations from "@/mixins/validations.js"

export default {
  name: 'ClientPF',
  mixins:[ validations ],
  props:{
    set_client:{
      type: Object,
      default: ()=>{ return {  } }
    },
    type:{
      type: String,
      default:"",
    }
  },
  data() {
    return {
      client: {
        name: '',
        CPF: ''
      }
    }
  },
  methods: {
    getData(){
      this.client.name = this.set_client.name
      this.client.CPF = this.formatCPFToMask(this.set_client.CPF)
    },
    validate(){
      return this.$refs.form.validate()
    },
    formatCPFToMask(cpf) {
      cpf = cpf.replace(/\D/g, '');
      cpf = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      return cpf;
    },
  },
  mounted(){
    this.getData()
  },
  watch:{
    type(nv){
      this.getData()
    }
  }
}
</script>